import React from 'react';

import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import Tooltip from 'ui-library/floating-ui/Tooltip';
import {ElementMouseEvent} from 'util/Types';

interface AddToUnitDictionaryButtonProps {
  added: boolean;
  onSetAdded: (selected: boolean) => void;
  // If this is set, the button will be disabled and shown as added
  forceSelectedText?: string | null;
}

export default function AddToUnitDictionaryButton({
  added,
  onSetAdded,
  forceSelectedText,
}: AddToUnitDictionaryButtonProps): JSX.Element {
  const addToDictionaryButton = (
    <Button
      size={ButtonSize.MINI}
      buttonStyle={ButtonStyle.TERTIARY_BLUE}
      text="Add to dictionary"
      onClick={(e: ElementMouseEvent) => {
        onSetAdded(true);
        e.stopPropagation();
      }}
    />
  );
  const addedButton =
    forceSelectedText != null ? (
      <Tooltip text={forceSelectedText}>
        <Button
          size={ButtonSize.MINI}
          buttonStyle={ButtonStyle.PRIMARY}
          text="Added"
          onClick={(e: ElementMouseEvent) => {
            onSetAdded(false);
            e.stopPropagation();
          }}
          disabled={true}
          icon="check"
        />
      </Tooltip>
    ) : (
      <Button
        size={ButtonSize.MINI}
        buttonStyle={ButtonStyle.PRIMARY}
        text="Added"
        onClick={(e: ElementMouseEvent) => {
          onSetAdded(false);
          e.stopPropagation();
        }}
        icon="check"
      />
    );

  return added ? addedButton : addToDictionaryButton;
}
